import {
  Grid,
  Typography,
  Modal,
  IconButton,
  Button,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const ProfileBuildingModal = ({ open, handleClose }) => {
  const options = [
    {
      label: "Exploration & Foundation",
      icon: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="22" fill="#EB3E12" fill-opacity="0.05" />
          <g clip-path="url(#clip0_6052_11263)">
            <path
              d="M22.0008 15.2616C19.7354 15.2616 17.9609 14.106 17.9609 12.6308C17.9609 11.1556 19.7354 10 22.0008 10C24.2661 10 26.0406 11.1556 26.0406 12.6308C26.0406 14.106 24.2661 15.2616 22.0008 15.2616ZM22.0008 11.1719C20.3106 11.1719 19.1328 11.9408 19.1328 12.6308C19.1328 13.3209 20.3106 14.0898 22.0008 14.0898C23.6909 14.0898 24.8687 13.3209 24.8687 12.6308C24.8687 11.9408 23.6909 11.1719 22.0008 11.1719Z"
              fill="url(#paint0_linear_6052_11263)"
            />
            <path
              d="M24.8688 12.6307C24.8688 13.3208 23.6909 14.0897 22.0008 14.0897C20.3107 14.0897 19.1329 13.3208 19.1329 12.6307C19.1329 12.2416 19.5074 11.8275 20.137 11.5403H18.3126C18.0868 11.871 17.9609 12.2394 17.9609 12.6307C17.9609 14.1059 19.7354 15.2615 22.0008 15.2615C24.2661 15.2615 26.0406 14.1059 26.0406 12.6307C26.0406 12.2394 25.9147 11.871 25.6889 11.5403H23.8646C24.4942 11.8275 24.8688 12.2416 24.8688 12.6307Z"
              fill="url(#paint1_linear_6052_11263)"
            />
            <path
              d="M22.0014 10C21.8922 10 21.7845 10.0035 21.6777 10.0088V11.1816C21.7834 11.1753 21.8912 11.1719 22.0014 11.1719C23.6915 11.1719 24.8694 11.9408 24.8694 12.6308C24.8694 13.3209 23.6915 14.0898 22.0014 14.0898C21.8912 14.0898 21.7834 14.0863 21.6777 14.08V15.2528C21.7845 15.2581 21.8922 15.2616 22.0014 15.2616C24.2667 15.2616 26.0412 14.106 26.0412 12.6308C26.0412 11.1556 24.2667 10 22.0014 10Z"
              fill="url(#paint2_linear_6052_11263)"
            />
            <path
              d="M24.8323 14.1894C24.8323 15.3203 19.168 15.3203 19.168 14.1894C19.168 13.0586 20.436 12.1418 22.0002 12.1418C23.5643 12.1418 24.8323 13.0586 24.8323 14.1894Z"
              fill="url(#paint3_linear_6052_11263)"
            />
            <path
              d="M24.8323 14.1894C24.8323 15.3203 19.168 15.3203 19.168 14.1894C19.168 13.0586 20.436 12.1418 22.0002 12.1418C23.5643 12.1418 24.8323 13.0586 24.8323 14.1894Z"
              fill="url(#paint4_linear_6052_11263)"
            />
            <path
              d="M22.0007 12.1418C21.8428 12.1418 21.688 12.1514 21.5371 12.1693V15.0274C23.0895 15.0961 24.8329 14.8169 24.8329 14.1894C24.8328 13.0586 23.5649 12.1418 22.0007 12.1418Z"
              fill="url(#paint5_linear_6052_11263)"
            />
            <path
              d="M22.0007 33.9999C27.5703 33.9999 32.0854 29.4849 32.0854 23.9153C32.0854 18.3456 27.5703 13.8306 22.0007 13.8306C16.4311 13.8306 11.916 18.3456 11.916 23.9153C11.916 29.4849 16.4311 33.9999 22.0007 33.9999Z"
              fill="url(#paint6_linear_6052_11263)"
            />
            <path
              d="M22.0009 32.045C26.4909 32.045 30.1307 28.4052 30.1307 23.9152C30.1307 19.4252 26.4909 15.7854 22.0009 15.7854C17.5109 15.7854 13.8711 19.4252 13.8711 23.9152C13.8711 28.4052 17.5109 32.045 22.0009 32.045Z"
              fill="url(#paint7_linear_6052_11263)"
            />
            <path
              d="M27.0482 17.5424C25.5737 16.3714 23.787 15.7854 22 15.7854V21.6493H27.0482V17.5424Z"
              fill="url(#paint8_linear_6052_11263)"
            />
            <path
              d="M11.916 23.9153C11.916 29.4849 16.4311 34 22.0007 34C27.5703 34 32.0854 29.4849 32.0854 23.9153C32.0854 22.709 31.8729 21.5526 31.4845 20.4805H12.5169C12.1285 21.5526 11.916 22.709 11.916 23.9153Z"
              fill="url(#paint9_linear_6052_11263)"
            />
            <path
              d="M14.8691 31.0462C18.8074 34.9845 25.1927 34.9845 29.131 31.0462C33.0693 27.1079 33.0693 20.7226 29.131 16.7844C28.278 15.9314 27.31 15.264 26.2773 14.7805L12.8652 28.1926C13.3487 29.2253 14.0162 30.1933 14.8691 31.0462Z"
              fill="url(#paint10_linear_6052_11263)"
            />
            <path
              d="M22.0016 30.7878C25.7973 30.7878 28.8743 27.7108 28.8743 23.9152C28.8743 20.1195 25.7973 17.0425 22.0016 17.0425C18.2059 17.0425 15.1289 20.1195 15.1289 23.9152C15.1289 27.7108 18.2059 30.7878 22.0016 30.7878Z"
              fill="url(#paint11_linear_6052_11263)"
            />
            <path
              d="M28.8743 23.9152C28.8743 20.1195 25.7972 17.0425 22.0016 17.0425C18.2059 17.0425 15.1289 20.1195 15.1289 23.9152C15.1289 24.7372 15.2737 25.5253 15.5384 26.2559H28.4648C28.7295 25.5253 28.8743 24.7372 28.8743 23.9152Z"
              fill="url(#paint12_linear_6052_11263)"
            />
            <path
              d="M26.8613 19.0554C24.1774 16.3715 19.8258 16.3715 17.1418 19.0554C14.4579 21.7394 14.4579 26.091 17.1418 28.7749C17.7231 29.3562 18.3828 29.811 19.0866 30.1405L28.2269 21.0002C27.8974 20.2964 27.4426 19.6367 26.8613 19.0554Z"
              fill="url(#paint13_linear_6052_11263)"
            />
            <path
              d="M26.8606 19.0554C25.5186 17.7134 23.7598 17.0425 22.0009 17.0425V23.9152L20.8887 25.0274L25.6204 29.7591C26.0612 29.4855 26.4779 29.1576 26.8606 28.7749C29.5446 26.091 29.5446 21.7394 26.8606 19.0554Z"
              fill="url(#paint14_linear_6052_11263)"
            />
            <path
              d="M22.0013 17.8796C21.8679 17.8796 21.7598 17.9878 21.7598 18.1212V19.0524C21.7598 19.1858 21.8679 19.294 22.0013 19.294C22.1347 19.294 22.2429 19.1858 22.2429 19.0524V18.1212C22.2429 17.9878 22.1347 17.8796 22.0013 17.8796Z"
              fill="url(#paint15_linear_6052_11263)"
            />
            <path
              d="M22.0013 28.5364C21.8679 28.5364 21.7598 28.6445 21.7598 28.7779V29.7091C21.7598 29.8425 21.8679 29.9507 22.0013 29.9507C22.1347 29.9507 22.2429 29.8425 22.2429 29.7091V28.7779C22.2429 28.6445 22.1347 28.5364 22.0013 28.5364Z"
              fill="url(#paint16_linear_6052_11263)"
            />
            <path
              d="M27.7939 23.6736H26.8626C26.7292 23.6736 26.6211 23.7817 26.6211 23.9151C26.6211 24.0485 26.7292 24.1567 26.8626 24.1567H27.7939C27.9273 24.1567 28.0354 24.0485 28.0354 23.9151C28.0354 23.7817 27.9273 23.6736 27.7939 23.6736Z"
              fill="url(#paint17_linear_6052_11263)"
            />
            <path
              d="M17.3792 23.9151C17.3792 23.7817 17.271 23.6736 17.1376 23.6736H16.2064C16.073 23.6736 15.9648 23.7817 15.9648 23.9151C15.9648 24.0485 16.073 24.1567 16.2064 24.1567H17.1376C17.271 24.1567 17.3792 24.0485 17.3792 23.9151Z"
              fill="url(#paint18_linear_6052_11263)"
            />
            <path
              d="M26.2681 19.6474C26.1738 19.5531 26.0208 19.5531 25.9265 19.6474L25.268 20.3059C25.1737 20.4002 25.1737 20.5532 25.268 20.6475C25.3623 20.7418 25.5153 20.7418 25.6096 20.6475L26.2681 19.989C26.3624 19.8947 26.3624 19.7418 26.2681 19.6474Z"
              fill="url(#paint19_linear_6052_11263)"
            />
            <path
              d="M18.7329 27.183C18.6386 27.0887 18.4857 27.0887 18.3913 27.183L17.7328 27.8415C17.6385 27.9359 17.6385 28.0888 17.7328 28.1831C17.8272 28.2774 17.9801 28.2774 18.0744 28.1831L18.7329 27.5246C18.8273 27.4303 18.8273 27.2774 18.7329 27.183Z"
              fill="url(#paint20_linear_6052_11263)"
            />
            <path
              d="M26.268 27.8415L25.6096 27.183C25.5153 27.0887 25.3623 27.0887 25.268 27.183C25.1737 27.2774 25.1737 27.4303 25.268 27.5246L25.9265 28.1831C26.0208 28.2774 26.1737 28.2774 26.268 28.1831C26.3623 28.0888 26.3623 27.9359 26.268 27.8415Z"
              fill="url(#paint21_linear_6052_11263)"
            />
            <path
              d="M18.7329 20.6475C18.8272 20.5532 18.8272 20.4002 18.7329 20.3059L18.0744 19.6474C17.9801 19.5531 17.8272 19.5531 17.7328 19.6474C17.6385 19.7417 17.6385 19.8947 17.7328 19.989L18.3913 20.6475C18.4857 20.7418 18.6386 20.7418 18.7329 20.6475Z"
              fill="url(#paint22_linear_6052_11263)"
            />
            <path
              d="M24.9035 20.8069L22.3265 15.9814C22.1871 15.7204 21.8129 15.7204 21.6735 15.9814L19.0965 20.8069C18.9906 21.0052 19.1821 21.2306 19.3949 21.1582L20.952 20.6281L20.5883 23.4091C20.5547 23.6656 20.7544 23.8931 21.0131 23.8931H22.9867C23.2454 23.8931 23.4451 23.6656 23.4115 23.4091L23.0478 20.6281L24.605 21.1582C24.8178 21.2306 25.0093 21.0052 24.9035 20.8069Z"
              fill="url(#paint23_linear_6052_11263)"
            />
            <path
              d="M22.9859 23.893H21.0125C20.7537 23.893 20.5541 23.6654 20.5877 23.409L20.9514 20.628L21.9992 20.2712L23.0471 20.628L23.4108 23.409C23.4443 23.6654 23.2447 23.893 22.9859 23.893Z"
              fill="url(#paint24_linear_6052_11263)"
            />
            <path
              d="M22.9868 23.8929C23.2455 23.8929 23.4452 23.6654 23.4116 23.4089L23.0479 20.6279L24.6051 21.158C24.8178 21.2304 25.0094 21.0049 24.9035 20.8067L22.3265 15.9812C22.2568 15.8507 22.1284 15.7854 22 15.7854V23.8929H22.9868Z"
              fill="url(#paint25_linear_6052_11263)"
            />
            <path
              d="M20.5877 23.4088C20.5541 23.6652 20.7537 23.8929 21.0125 23.8929H22.986C23.2448 23.8929 23.4444 23.6652 23.4108 23.4088L23.1429 21.3601H20.8557L20.5877 23.4088Z"
              fill="url(#paint26_linear_6052_11263)"
            />
            <path
              d="M22.0006 25.4882C22.8692 25.4882 23.5734 24.784 23.5734 23.9154C23.5734 23.0467 22.8692 22.3425 22.0006 22.3425C21.1319 22.3425 20.4277 23.0467 20.4277 23.9154C20.4277 24.784 21.1319 25.4882 22.0006 25.4882Z"
              fill="url(#paint27_linear_6052_11263)"
            />
            <path
              d="M20.4277 23.9154C20.4277 24.7841 21.1319 25.4882 22.0006 25.4882C22.8693 25.4882 23.5734 24.784 23.5734 23.9154C23.5734 23.7273 23.5403 23.5469 23.4797 23.3796H20.5214C20.4609 23.5469 20.4277 23.7273 20.4277 23.9154Z"
              fill="url(#paint28_linear_6052_11263)"
            />
            <path
              d="M20.8887 25.0276C21.503 25.6418 22.4988 25.6418 23.1131 25.0276C23.7273 24.4133 23.7273 23.4175 23.1131 22.8032C22.9801 22.6702 22.8291 22.5661 22.668 22.4907L20.5762 24.5826C20.6516 24.7436 20.7557 24.8946 20.8887 25.0276Z"
              fill="url(#paint29_linear_6052_11263)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_6052_11263"
              x1="21.3478"
              y1="9.74805"
              x2="22.5285"
              y2="14.9609"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EAF9FA" />
              <stop offset="1" stop-color="#B3DAFE" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_6052_11263"
              x1="22.0008"
              y1="12.6542"
              x2="22.0008"
              y2="14.2445"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_6052_11263"
              x1="23.6547"
              y1="13.1839"
              x2="25.3923"
              y2="14.0527"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_6052_11263"
              x1="22.0398"
              y1="12.5959"
              x2="21.9849"
              y2="14.7935"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5A5A5A" />
              <stop offset="1" stop-color="#444444" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_6052_11263"
              x1="22.0002"
              y1="12.7768"
              x2="22.0002"
              y2="14.1134"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#433F43" stop-opacity="0" />
              <stop offset="1" stop-color="#1A1A1A" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_6052_11263"
              x1="22.8955"
              y1="13.4518"
              x2="24.5725"
              y2="12.9358"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#433F43" stop-opacity="0" />
              <stop offset="1" stop-color="#1A1A1A" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_6052_11263"
              x1="15.832"
              y1="17.7466"
              x2="26.9599"
              y2="28.8745"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5A5A5A" />
              <stop offset="1" stop-color="#444444" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_6052_11263"
              x1="27.691"
              y1="29.6053"
              x2="15.4446"
              y2="17.3589"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5A5A5A" />
              <stop offset="1" stop-color="#444444" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_6052_11263"
              x1="24.7629"
              y1="18.6321"
              x2="23.5154"
              y2="19.0776"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#433F43" stop-opacity="0" />
              <stop offset="1" stop-color="#1A1A1A" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_6052_11263"
              x1="22.0007"
              y1="24.0429"
              x2="22.0007"
              y2="35.9062"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#433F43" stop-opacity="0" />
              <stop offset="1" stop-color="#1A1A1A" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_6052_11263"
              x1="22.0949"
              y1="24.0187"
              x2="30.9248"
              y2="32.8486"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#433F43" stop-opacity="0" />
              <stop offset="1" stop-color="#1A1A1A" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_6052_11263"
              x1="26.2055"
              y1="28.1191"
              x2="18.6218"
              y2="20.5355"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EAF9FA" />
              <stop offset="1" stop-color="#B3DAFE" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_6052_11263"
              x1="21.2153"
              y1="21.6137"
              x2="19.557"
              y2="16.7617"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_6052_11263"
              x1="18.6264"
              y1="22.2948"
              x2="15.5554"
              y2="20.8207"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_6052_11263"
              x1="25.2938"
              y1="23.5982"
              x2="20.4151"
              y2="22.7962"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_6052_11263"
              x1="48.3673"
              y1="36.6645"
              x2="17.2262"
              y2="15.3127"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_6052_11263"
              x1="43.3971"
              y1="43.9134"
              x2="12.256"
              y2="22.5616"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint17_linear_6052_11263"
              x1="47.5846"
              y1="37.8037"
              x2="16.4435"
              y2="16.4521"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint18_linear_6052_11263"
              x1="44.1774"
              y1="42.774"
              x2="13.0363"
              y2="21.4223"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint19_linear_6052_11263"
              x1="31.6287"
              y1="51.5713"
              x2="24.7066"
              y2="14.4532"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint20_linear_6052_11263"
              x1="22.9888"
              y1="53.1827"
              x2="16.0667"
              y2="16.0647"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint21_linear_6052_11263"
              x1="30.2706"
              y1="51.8247"
              x2="23.3485"
              y2="14.7067"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint22_linear_6052_11263"
              x1="24.3469"
              y1="52.9294"
              x2="17.4247"
              y2="15.8114"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BACDF" stop-opacity="0" />
              <stop offset="1" stop-color="#7BACDF" />
            </linearGradient>
            <linearGradient
              id="paint23_linear_6052_11263"
              x1="21.0483"
              y1="19.8394"
              x2="23.6067"
              y2="19.8394"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FD4755" />
              <stop offset="0.336" stop-color="#E43F48" />
              <stop offset="1" stop-color="#A72B2B" />
            </linearGradient>
            <linearGradient
              id="paint24_linear_6052_11263"
              x1="22.3858"
              y1="22.0957"
              x2="23.2854"
              y2="21.9932"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A72B2B" stop-opacity="0" />
              <stop offset="1" stop-color="#481F05" />
            </linearGradient>
            <linearGradient
              id="paint25_linear_6052_11263"
              x1="22.7609"
              y1="20.1189"
              x2="19.9681"
              y2="19.0427"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A72B2B" stop-opacity="0" />
              <stop offset="1" stop-color="#481F05" />
            </linearGradient>
            <linearGradient
              id="paint26_linear_6052_11263"
              x1="21.9992"
              y1="22.9966"
              x2="21.9992"
              y2="23.8534"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A72B2B" stop-opacity="0" />
              <stop offset="1" stop-color="#481F05" />
            </linearGradient>
            <linearGradient
              id="paint27_linear_6052_11263"
              x1="21.1515"
              y1="23.0663"
              x2="22.996"
              y2="24.9108"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEF0AE" />
              <stop offset="1" stop-color="#FBC56D" />
            </linearGradient>
            <linearGradient
              id="paint28_linear_6052_11263"
              x1="22.0006"
              y1="23.8343"
              x2="22.0006"
              y2="25.5492"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#DC8758" stop-opacity="0" />
              <stop offset="0.215" stop-color="#DD8654" stop-opacity="0.215" />
              <stop offset="0.429" stop-color="#E28448" stop-opacity="0.429" />
              <stop offset="0.642" stop-color="#EA8034" stop-opacity="0.642" />
              <stop offset="0.854" stop-color="#F47B18" stop-opacity="0.854" />
              <stop offset="1" stop-color="#FE7701" />
            </linearGradient>
            <linearGradient
              id="paint29_linear_6052_11263"
              x1="21.8988"
              y1="23.8274"
              x2="23.2688"
              y2="25.0091"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#DC8758" stop-opacity="0" />
              <stop offset="0.215" stop-color="#DD8654" stop-opacity="0.215" />
              <stop offset="0.429" stop-color="#E28448" stop-opacity="0.429" />
              <stop offset="0.642" stop-color="#EA8034" stop-opacity="0.642" />
              <stop offset="0.854" stop-color="#F47B18" stop-opacity="0.854" />
              <stop offset="1" stop-color="#FE7701" />
            </linearGradient>
            <clipPath id="clip0_6052_11263">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(10 10)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      label: "Research",
      icon: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="22" fill="#DBEAFE" fillOpacity="0.38" />
          <path
            d="M12.2499 32.5C12.0549 32.5 11.8674 32.425 11.7174 32.2825C11.4249 31.99 11.4249 31.5175 11.7174 31.225L16.2174 26.725C16.5099 26.4325 16.9824 26.4325 17.2749 26.725C17.5674 27.0175 17.5674 27.49 17.2749 27.7825L12.7749 32.2825C12.6249 32.4325 12.4374 32.5 12.2424 32.5H12.2499Z"
            fill="#00A0ED"
          />
          <path
            d="M23.125 11.5C17.9575 11.5 13.75 15.7075 13.75 20.875C13.75 26.0425 17.9575 30.25 23.125 30.25C28.2925 30.25 32.5 26.0425 32.5 20.875C32.5 15.7075 28.2925 11.5 23.125 11.5Z"
            fill="#FFCD0F"
          />
          <path
            d="M26.875 24.25C26.4625 24.25 26.125 23.9125 26.125 23.5V19.75C26.125 19.3375 26.4625 19 26.875 19C27.2875 19 27.625 19.3375 27.625 19.75V23.5C27.625 23.9125 27.2875 24.25 26.875 24.25ZM23.125 24.25C22.7125 24.25 22.375 23.9125 22.375 23.5V18.25C22.375 17.8375 22.7125 17.5 23.125 17.5C23.5375 17.5 23.875 17.8375 23.875 18.25V23.5C23.875 23.9125 23.5375 24.25 23.125 24.25ZM19.375 24.25C18.9625 24.25 18.625 23.9125 18.625 23.5V21.25C18.625 20.8375 18.9625 20.5 19.375 20.5C19.7875 20.5 20.125 20.8375 20.125 21.25V23.5C20.125 23.9125 19.7875 24.25 19.375 24.25Z"
            fill="#00A0ED"
          />
        </svg>
      ),
    },
    {
      label: "Test Prep",
      icon: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="22" fill="#4469FD" fill-opacity="0.07" />
          <g clip-path="url(#clip0_6052_11323)">
            <path
              d="M20.9028 21.6012C20.6106 21.6425 20.4095 21.9072 20.4525 22.1908C20.4665 22.2929 20.5101 22.3886 20.5779 22.4662C20.6457 22.5437 20.7348 22.5998 20.8341 22.6273C20.8341 22.6273 22.118 23.0502 24.3025 23.2306C26.0573 23.3767 28.0494 23.1052 28.0494 23.1052C28.3416 23.0983 28.5702 22.8559 28.5633 22.5637C28.5616 22.4944 28.5463 22.4261 28.5181 22.3627C28.49 22.2993 28.4496 22.2421 28.3993 22.1944C28.349 22.1466 28.2898 22.1093 28.225 22.0845C28.1602 22.0597 28.0912 22.0479 28.0219 22.0498C27.9875 22.0498 27.9531 22.0567 27.917 22.0636C27.917 22.0636 25.968 22.3059 24.385 22.1753C22.2967 22.0086 21.1589 21.627 21.1589 21.627C21.0764 21.5995 20.9853 21.5858 20.9028 21.5995V21.6012ZM20.9028 18.9853C20.6106 19.0266 20.4095 19.2913 20.4525 19.5748C20.4665 19.6769 20.5101 19.7727 20.5779 19.8502C20.6457 19.9278 20.7348 19.9838 20.8341 20.0114C20.8341 20.0114 22.118 20.4342 24.3025 20.6147C26.0573 20.7608 28.0494 20.4892 28.0494 20.4892C28.3416 20.4823 28.5702 20.24 28.5633 19.9478C28.5616 19.8785 28.5463 19.8102 28.5181 19.7468C28.49 19.6834 28.4496 19.6262 28.3993 19.5784C28.349 19.5307 28.2898 19.4933 28.225 19.4685C28.1602 19.4437 28.0912 19.432 28.0219 19.4339C27.9875 19.4339 27.9531 19.4408 27.917 19.4477C27.917 19.4477 25.968 19.69 24.385 19.5594C22.2967 19.3927 21.1589 19.0111 21.1589 19.0111C21.0764 18.9836 20.9853 18.9698 20.9028 18.9836V18.9853ZM20.9028 16.3694C20.6106 16.4106 20.4095 16.6753 20.4525 16.9589C20.4665 17.061 20.5101 17.1567 20.5779 17.2343C20.6457 17.3119 20.7348 17.3679 20.8341 17.3955C20.8341 17.3955 22.118 17.8183 24.3025 17.9988C26.0573 18.1448 28.0494 17.8733 28.0494 17.8733C28.3416 17.8664 28.5702 17.6241 28.5633 17.3319C28.5616 17.2625 28.5463 17.1942 28.5181 17.1308C28.49 17.0674 28.4496 17.0102 28.3993 16.9625C28.349 16.9147 28.2898 16.8774 28.225 16.8526C28.1602 16.8278 28.0912 16.816 28.0219 16.818C27.9875 16.818 27.9531 16.8248 27.917 16.8317C27.917 16.8317 25.968 17.0741 24.385 16.9434C22.2967 16.7767 21.1589 16.3952 21.1589 16.3952C21.0764 16.3677 20.9853 16.3608 20.9028 16.3677V16.3694ZM20.9028 13.7603C20.6106 13.8016 20.4095 14.0662 20.4525 14.3498C20.4665 14.4519 20.5101 14.5477 20.5779 14.6252C20.6457 14.7028 20.7348 14.7588 20.8341 14.7864C20.8341 14.7864 22.118 15.2092 24.3025 15.3897C26.0573 15.5358 28.0494 15.2642 28.0494 15.2642C28.3416 15.2573 28.5702 15.015 28.5633 14.7228C28.5616 14.6535 28.5463 14.5852 28.5181 14.5218C28.49 14.4584 28.4496 14.4012 28.3993 14.3534C28.349 14.3057 28.2898 14.2683 28.225 14.2435C28.1602 14.2187 28.0912 14.207 28.0219 14.2089C27.9875 14.2089 27.9531 14.2158 27.917 14.2227C27.917 14.2227 25.968 14.465 24.385 14.3344C22.2967 14.1677 21.1589 13.7861 21.1589 13.7861C21.0778 13.7533 20.9891 13.7438 20.9028 13.7586V13.7603ZM17.2402 11C14.4919 11.0206 13.4727 11.868 13.4727 11.868V32.3847C13.4727 32.3847 14.4713 31.5236 17.6905 31.6559C20.9097 31.7883 21.5697 32.9192 25.5245 32.9948C29.4794 33.0705 30.4711 32.3847 30.4711 32.3847L30.5261 11.4727C30.5261 11.4727 28.7506 11.9797 25.2805 12.0072C21.8189 12.033 20.987 11.1255 17.8091 11.0206C17.6148 11.0069 17.4275 11 17.2402 11ZM19.5364 12.3389C19.5364 12.3389 21.2019 12.8872 24.275 13.0402C26.8772 13.1725 29.4794 12.7841 29.4794 12.7841V31.3723C29.4794 31.3723 28.1611 32.0667 24.8662 31.8295C22.3122 31.6491 19.5037 30.678 19.5037 30.678L19.5381 12.3406L19.5364 12.3389ZM17.9345 12.8253C18.2267 12.8253 18.4691 13.0608 18.4691 13.3598C18.4691 13.6589 18.2336 13.8944 17.9345 13.8944C17.9345 13.8944 17.0734 13.9012 16.5475 13.9494C15.6658 14.0387 15.0625 14.3584 15.0625 14.3584C14.8064 14.4977 14.4798 14.3928 14.3475 14.1367C14.2083 13.8806 14.3131 13.5541 14.5692 13.4217C14.8253 13.2894 15.353 13.0058 16.4427 12.9009C17.0734 12.8322 17.9345 12.8253 17.9345 12.8253ZM17.4206 15.4481C17.7128 15.4412 17.9345 15.4481 17.9345 15.4481C18.2267 15.4825 18.4347 15.7472 18.3986 16.0377C18.3847 16.1559 18.3314 16.2661 18.2472 16.3503C18.1629 16.4345 18.0528 16.4878 17.9345 16.5017C17.9345 16.5017 17.0734 16.5086 16.5475 16.5567C15.6658 16.6461 15.0625 16.9658 15.0625 16.9658C14.8064 17.105 14.4798 17.0002 14.3475 16.7441C14.2083 16.488 14.3131 16.1614 14.5692 16.0291C14.5692 16.0291 15.353 15.6131 16.4427 15.5083C16.7623 15.467 17.1302 15.4533 17.4206 15.4464V15.4481ZM17.9345 18.0572C18.2267 18.0572 18.4691 18.2927 18.4691 18.5917C18.4691 18.8908 18.2336 19.1262 17.9345 19.1262C17.9345 19.1262 17.0734 19.1194 16.5475 19.1744C15.6658 19.2638 15.0625 19.5834 15.0625 19.5834C14.8064 19.7227 14.4798 19.6178 14.3475 19.3617C14.2083 19.1056 14.3131 18.7791 14.5692 18.6467C14.5692 18.6467 15.353 18.2308 16.4427 18.1259C17.0734 18.0503 17.9345 18.0572 17.9345 18.0572Z"
              fill="#4469FD"
            />
          </g>
          <defs>
            <clipPath id="clip0_6052_11323">
              <rect
                width="22"
                height="22"
                fill="white"
                transform="translate(11 11)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      label: "Skill Building",
      icon: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="22" fill="#FD551C" fill-opacity="0.05" />
          <g clip-path="url(#clip0_6052_11335)">
            <path
              d="M30.0623 17.0351H29.2729C29.2187 16.9162 29.158 16.7928 29.0882 16.659C28.9642 16.3228 28.8151 15.9963 28.6421 15.6824C28.6421 15.6824 29.221 15.1161 29.2219 15.1153C29.4672 14.8687 29.6046 14.5349 29.604 14.1871C29.6034 13.8393 29.4649 13.506 29.2187 13.2603C29.2187 13.2603 28.0229 12.0931 28.0213 12.0916C27.771 11.8569 27.4407 11.7263 27.0976 11.7263C26.7544 11.7263 26.4241 11.8571 26.1739 12.0919L25.5918 12.6591C25.5843 12.6606 25.5766 12.6613 25.569 12.6613C25.5598 12.6615 25.5506 12.6603 25.5418 12.6578C25.1009 12.4286 24.639 12.2423 24.1624 12.1016V11.3017C24.1601 10.9547 24.0202 10.6227 23.7735 10.3787C23.5267 10.1347 23.1932 9.99849 22.8462 10H21.1519C20.8044 9.99878 20.4706 10.1354 20.2237 10.38C19.9768 10.6246 19.837 10.9571 19.835 11.3046V12.0896C19.8281 12.0974 19.8198 12.1039 19.8106 12.1087C19.3428 12.2491 18.8891 12.4331 18.4556 12.6583C18.4388 12.664 18.4206 12.6641 18.4037 12.6585L17.8243 12.0921C17.5746 11.857 17.2447 11.7259 16.9017 11.7255C16.5587 11.7251 16.2285 11.8553 15.9781 12.0896L14.7761 13.2628C14.6541 13.3843 14.5573 13.5287 14.4913 13.6877C14.4252 13.8467 14.3912 14.0172 14.3912 14.1893C14.3912 14.3615 14.4252 14.532 14.4913 14.691C14.5573 14.85 14.6541 14.9944 14.7761 15.1159L15.3562 15.6821C15.1833 15.9973 15.0341 16.3251 14.91 16.6626C14.8423 16.7927 14.7819 16.916 14.7278 17.0351H13.9393C13.5925 17.0338 13.2593 17.1702 13.0129 17.4143C12.7665 17.6584 12.627 17.9903 12.625 18.3371V19.9905C12.6272 20.3372 12.7667 20.6689 13.0131 20.9129C13.2595 21.1568 13.5926 21.293 13.9393 21.2917L14.2051 21.2931C14.2117 21.293 14.2182 21.2945 14.2241 21.2974C14.3504 21.9427 14.5516 22.571 14.8235 23.1696L14.7759 23.2124C14.652 23.3327 14.5535 23.4768 14.4863 23.636C14.4191 23.7952 14.3845 23.9662 14.3847 24.139C14.3849 24.3118 14.4198 24.4828 14.4874 24.6418C14.5549 24.8008 14.6538 24.9447 14.778 25.0648L15.9759 26.2346C16.2063 26.4584 16.5104 26.5905 16.8311 26.606C17.5707 27.7645 18.1995 28.8192 18.4655 30.6375C18.4759 30.8149 18.4732 30.9928 18.4573 31.1697C18.4613 31.5604 18.6028 31.9373 18.857 32.2341C19.1112 32.5308 19.4618 32.7286 19.8473 32.7927C19.876 33.1232 20.028 33.4307 20.273 33.6544C20.518 33.8781 20.8381 34.0014 21.1699 34H22.8302C23.162 34.0014 23.4822 33.878 23.7273 33.6542C23.9723 33.4304 24.1242 33.1226 24.1528 32.792C24.5243 32.7224 24.8621 32.5314 25.1132 32.2489C25.3642 31.9664 25.5143 31.6085 25.5399 31.2315C25.7052 29.2225 26.1801 28.1048 27.1065 26.6076C27.4483 26.6075 27.7766 26.4737 28.0212 26.2349L29.2214 25.0628C29.3437 24.9413 29.4406 24.7967 29.5067 24.6375C29.5727 24.4782 29.6066 24.3075 29.6063 24.1351C29.6059 23.9627 29.5714 23.7921 29.5048 23.6331C29.4381 23.4741 29.3406 23.3299 29.2179 23.2089L29.1662 23.1582C29.4466 22.566 29.6522 21.9411 29.7785 21.2981C29.7838 21.2948 29.79 21.293 29.7963 21.2931L30.0635 21.2916C30.4098 21.2924 30.7422 21.1558 30.988 20.912C31.2338 20.6681 31.373 20.3368 31.375 19.9905V18.3356C31.373 17.9892 31.2336 17.6577 30.9875 17.4139C30.7414 17.1701 30.4087 17.0338 30.0623 17.0351ZM17.121 16.3856C17.1952 16.3856 17.2677 16.4076 17.3294 16.4488C17.391 16.49 17.4391 16.5486 17.4675 16.6171C17.4959 16.6856 17.5033 16.761 17.4888 16.8338C17.4743 16.9065 17.4386 16.9733 17.3862 17.0258C17.3337 17.0782 17.2669 17.1139 17.1942 17.1284C17.1214 17.1429 17.046 17.1354 16.9775 17.1071C16.909 17.0787 16.8504 17.0306 16.8092 16.9689C16.768 16.9073 16.746 16.8348 16.746 16.7606C16.746 16.6612 16.7855 16.5658 16.8559 16.4954C16.9262 16.4251 17.0216 16.3856 17.121 16.3856ZM16.5621 17.7432C16.6363 17.7432 16.7088 17.7652 16.7705 17.8064C16.8322 17.8476 16.8802 17.9061 16.9086 17.9747C16.937 18.0432 16.9444 18.1186 16.9299 18.1913C16.9155 18.2641 16.8798 18.3309 16.8273 18.3833C16.7749 18.4358 16.7081 18.4715 16.6353 18.486C16.5626 18.5004 16.4872 18.493 16.4186 18.4646C16.3501 18.4362 16.2916 18.3882 16.2503 18.3265C16.2091 18.2648 16.1871 18.1923 16.1871 18.1182C16.1871 18.0187 16.2267 17.9233 16.297 17.853C16.3673 17.7827 16.4627 17.7432 16.5621 17.7432ZM16 19.5737C16 19.4995 16.022 19.427 16.0632 19.3653C16.1044 19.3037 16.163 19.2556 16.2315 19.2272C16.3 19.1988 16.3754 19.1914 16.4482 19.2059C16.5209 19.2204 16.5877 19.2561 16.6402 19.3085C16.6926 19.361 16.7283 19.4278 16.7428 19.5005C16.7573 19.5733 16.7498 19.6487 16.7215 19.7172C16.6931 19.7857 16.645 19.8443 16.5833 19.8855C16.5217 19.9267 16.4492 19.9487 16.375 19.9487C16.2755 19.9487 16.1802 19.9092 16.1098 19.8388C16.0395 19.7685 16 19.6731 16 19.5737ZM16.1931 21.0286C16.1931 20.9544 16.2151 20.8819 16.2563 20.8203C16.2975 20.7586 16.3561 20.7105 16.4246 20.6821C16.4931 20.6538 16.5685 20.6463 16.6413 20.6608C16.714 20.6753 16.7808 20.711 16.8333 20.7634C16.8857 20.8159 16.9214 20.8827 16.9359 20.9554C16.9504 21.0282 16.9429 21.1036 16.9146 21.1721C16.8862 21.2406 16.8381 21.2992 16.7764 21.3404C16.7148 21.3816 16.6423 21.4036 16.5681 21.4036C16.4686 21.4036 16.3733 21.3641 16.3029 21.2938C16.2326 21.2234 16.1931 21.1281 16.1931 21.0286ZM17.132 22.7586C17.0579 22.7586 16.9854 22.7366 16.9237 22.6954C16.862 22.6541 16.814 22.5956 16.7856 22.5271C16.7572 22.4585 16.7498 22.3831 16.7642 22.3104C16.7787 22.2376 16.8144 22.1708 16.8669 22.1184C16.9193 22.0659 16.9861 22.0302 17.0589 22.0158C17.1316 22.0013 17.207 22.0087 17.2755 22.0371C17.3441 22.0655 17.4026 22.1135 17.4438 22.1752C17.485 22.2369 17.507 22.3094 17.507 22.3836C17.507 22.4328 17.4973 22.4816 17.4785 22.5271C17.4596 22.5726 17.432 22.6139 17.3972 22.6487C17.3624 22.6835 17.321 22.7112 17.2755 22.73C17.23 22.7488 17.1813 22.7586 17.132 22.7586ZM18.0129 15.2196C18.0871 15.2196 18.1596 15.2416 18.2212 15.2828C18.2829 15.324 18.331 15.3826 18.3594 15.4511C18.3877 15.5196 18.3952 15.595 18.3807 15.6678C18.3662 15.7405 18.3305 15.8073 18.2781 15.8598C18.2256 15.9122 18.1588 15.9479 18.0861 15.9624C18.0133 15.9769 17.9379 15.9695 17.8694 15.9411C17.8009 15.9127 17.7423 15.8646 17.7011 15.803C17.6599 15.7413 17.6379 15.6688 17.6379 15.5946C17.6379 15.4952 17.6774 15.3998 17.7477 15.3295C17.8181 15.2591 17.9134 15.2196 18.0129 15.2196ZM18.0279 23.9205C17.9537 23.9205 17.8812 23.8985 17.8195 23.8573C17.7579 23.8161 17.7098 23.7575 17.6814 23.689C17.653 23.6205 17.6456 23.5451 17.6601 23.4723C17.6746 23.3996 17.7103 23.3328 17.7627 23.2803C17.8152 23.2279 17.882 23.1922 17.9547 23.1777C18.0275 23.1632 18.1029 23.1707 18.1714 23.199C18.2399 23.2274 18.2985 23.2755 18.3397 23.3372C18.3809 23.3988 18.4029 23.4713 18.4029 23.5455C18.4029 23.5947 18.3932 23.6435 18.3743 23.689C18.3555 23.7345 18.3279 23.7758 18.293 23.8107C18.2582 23.8455 18.2169 23.8731 18.1714 23.8919C18.1259 23.9108 18.0771 23.9205 18.0279 23.9205ZM24.7965 14.3053C24.8707 14.3053 24.9432 14.3273 25.0049 14.3685C25.0666 14.4098 25.1146 14.4683 25.143 14.5368C25.1714 14.6054 25.1788 14.6808 25.1643 14.7535C25.1499 14.8263 25.1142 14.8931 25.0617 14.9455C25.0093 14.998 24.9424 15.0337 24.8697 15.0481C24.797 15.0626 24.7216 15.0552 24.653 15.0268C24.5845 14.9984 24.526 14.9504 24.4847 14.8887C24.4435 14.827 24.4215 14.7545 24.4215 14.6803C24.4215 14.5809 24.4611 14.4855 24.5314 14.4152C24.6017 14.3449 24.6971 14.3053 24.7965 14.3053ZM23.439 13.7481C23.5131 13.7481 23.5856 13.7701 23.6473 13.8113C23.709 13.8525 23.757 13.9111 23.7854 13.9796C23.8138 14.0482 23.8212 14.1236 23.8068 14.1963C23.7923 14.269 23.7566 14.3359 23.7041 14.3883C23.6517 14.4407 23.5849 14.4765 23.5121 14.4909C23.4394 14.5054 23.364 14.498 23.2955 14.4696C23.2269 14.4412 23.1684 14.3931 23.1272 14.3315C23.086 14.2698 23.064 14.1973 23.064 14.1231C23.064 14.0237 23.1035 13.9283 23.1738 13.858C23.2441 13.7876 23.3395 13.7481 23.439 13.7481ZM21.9831 13.5625C22.0573 13.5625 22.1298 13.5845 22.1914 13.6257C22.2531 13.6669 22.3012 13.7255 22.3296 13.794C22.3579 13.8625 22.3654 13.9379 22.3509 14.0107C22.3364 14.0834 22.3007 14.1502 22.2483 14.2027C22.1958 14.2551 22.129 14.2908 22.0563 14.3053C21.9835 14.3198 21.9081 14.3123 21.8396 14.284C21.7711 14.2556 21.7125 14.2075 21.6713 14.1458C21.6301 14.0842 21.6081 14.0117 21.6081 13.9375C21.6081 13.8883 21.6178 13.8395 21.6366 13.794C21.6555 13.7485 21.6831 13.7072 21.7179 13.6723C21.7528 13.6375 21.7941 13.6099 21.8396 13.591C21.8851 13.5722 21.9339 13.5625 21.9831 13.5625ZM22 15.625C22.4474 15.6255 22.8763 15.8034 23.1927 16.1198C23.5091 16.4362 23.687 16.8651 23.6875 17.3125V18.25C23.6875 18.6976 23.5097 19.1268 23.1932 19.4433C22.8768 19.7597 22.4476 19.9375 22 19.9375C21.5524 19.9375 21.1232 19.7597 20.8068 19.4433C20.4903 19.1268 20.3125 18.6976 20.3125 18.25V17.3125C20.313 16.8651 20.491 16.4362 20.8073 16.1198C21.1237 15.8035 21.5526 15.6255 22 15.625ZM20.5281 13.7574C20.6022 13.7574 20.6747 13.7794 20.7364 13.8206C20.7981 13.8618 20.8461 13.9204 20.8745 13.9889C20.9029 14.0574 20.9103 14.1328 20.8959 14.2056C20.8814 14.2783 20.8457 14.3451 20.7932 14.3976C20.7408 14.45 20.674 14.4857 20.6012 14.5002C20.5285 14.5147 20.4531 14.5072 20.3846 14.4789C20.316 14.4505 20.2575 14.4024 20.2163 14.3407C20.1751 14.2791 20.1531 14.2066 20.1531 14.1324C20.1531 14.0329 20.1926 13.9376 20.2629 13.8672C20.3332 13.7969 20.4286 13.7574 20.5281 13.7574ZM19.1743 14.3053C19.2485 14.3053 19.321 14.3273 19.3827 14.3685C19.4443 14.4098 19.4924 14.4683 19.5208 14.5368C19.5492 14.6054 19.5566 14.6808 19.5421 14.7535C19.5277 14.8263 19.4919 14.8931 19.4395 14.9455C19.3871 14.998 19.3202 15.0337 19.2475 15.0481C19.1748 15.0626 19.0994 15.0552 19.0308 15.0268C18.9623 14.9984 18.9037 14.9504 18.8625 14.8887C18.8213 14.827 18.7993 14.7545 18.7993 14.6803C18.7993 14.5809 18.8388 14.4855 18.9092 14.4152C18.9795 14.3449 19.0749 14.3053 19.1743 14.3053ZM19.1937 24.8081C19.1195 24.8081 19.047 24.7861 18.9854 24.7449C18.9237 24.7037 18.8756 24.6451 18.8473 24.5766C18.8189 24.5081 18.8114 24.4327 18.8259 24.3599C18.8404 24.2872 18.8761 24.2204 18.9285 24.1679C18.981 24.1155 19.0478 24.0798 19.1206 24.0653C19.1933 24.0508 19.2687 24.0583 19.3372 24.0866C19.4057 24.115 19.4643 24.1631 19.5055 24.2248C19.5467 24.2864 19.5687 24.3589 19.5687 24.4331C19.5687 24.5326 19.5292 24.6279 19.4589 24.6983C19.3886 24.7686 19.2932 24.8081 19.1937 24.8081ZM19.5625 21.5115V22.1859C19.5625 22.2853 19.523 22.3807 19.4527 22.451C19.3823 22.5214 19.287 22.5609 19.1875 22.5609C19.088 22.5609 18.9927 22.5214 18.9223 22.451C18.852 22.3807 18.8125 22.2853 18.8125 22.1859V21.5115C18.8125 20.5957 19.2787 19.918 20.0218 19.6686C20.2065 19.9254 20.4392 20.1441 20.7069 20.3125H20.6875C19.9831 20.3125 19.5625 20.7608 19.5625 21.5115ZM23.7684 24.1577L23.1506 24.7909L23.2971 25.6896C23.3085 25.7591 23.3001 25.8304 23.2728 25.8953C23.2456 25.9602 23.2005 26.0161 23.1429 26.0565C23.085 26.0962 23.0174 26.1191 22.9473 26.1229C22.8772 26.1268 22.8075 26.1113 22.7456 26.0781L22 25.666L21.2544 26.0781C21.1928 26.1122 21.1229 26.1282 21.0526 26.1244C20.9823 26.1206 20.9145 26.0971 20.857 26.0565C20.7994 26.016 20.7544 25.9601 20.7272 25.8952C20.6999 25.8303 20.6915 25.7591 20.7028 25.6896L20.8495 24.7909L20.2316 24.1577C20.1834 24.1084 20.1498 24.0467 20.1345 23.9795C20.1191 23.9123 20.1225 23.8422 20.1444 23.7769C20.1663 23.7115 20.2058 23.6534 20.2585 23.6091C20.3112 23.5647 20.3752 23.5357 20.4433 23.5253L21.282 23.3971L21.6605 22.5907C21.6908 22.5262 21.7388 22.4717 21.7989 22.4335C21.859 22.3953 21.9288 22.375 22 22.375C22.0712 22.375 22.141 22.3953 22.2011 22.4335C22.2612 22.4717 22.3092 22.5262 22.3395 22.5907L22.718 23.3971L23.5566 23.5251C23.6247 23.5355 23.6887 23.5645 23.7414 23.6089C23.7942 23.6533 23.8337 23.7114 23.8556 23.7768C23.8774 23.8421 23.8809 23.9123 23.8655 23.9795C23.8502 24.0467 23.8166 24.1084 23.7684 24.1577ZM23.3125 20.3125H23.293C23.5608 20.1441 23.7934 19.9254 23.9782 19.6686C24.7213 19.918 25.1875 20.5957 25.1875 21.5115V22.1859C25.1875 22.2853 25.148 22.3807 25.0777 22.451C25.0073 22.5214 24.912 22.5609 24.8125 22.5609C24.713 22.5609 24.6177 22.5214 24.5473 22.451C24.477 22.3807 24.4375 22.2853 24.4375 22.1859V21.5115C24.4375 20.7608 24.0169 20.3125 23.3125 20.3125ZM24.8158 24.8081C24.7416 24.8081 24.6691 24.7861 24.6074 24.7449C24.5458 24.7037 24.4977 24.6451 24.4693 24.5766C24.4409 24.5081 24.4335 24.4327 24.448 24.3599C24.4625 24.2872 24.4982 24.2204 24.5506 24.1679C24.6031 24.1155 24.6699 24.0798 24.7426 24.0653C24.8154 24.0508 24.8908 24.0583 24.9593 24.0866C25.0278 24.115 25.0864 24.1631 25.1276 24.2248C25.1688 24.2864 25.1908 24.3589 25.1908 24.4331C25.1908 24.5326 25.1513 24.6279 25.0809 24.6983C25.0106 24.7686 24.9152 24.8081 24.8158 24.8081ZM27.8031 18.0849C27.8031 18.1591 27.7811 18.2316 27.7399 18.2933C27.6987 18.3549 27.6401 18.403 27.5716 18.4314C27.5031 18.4598 27.4277 18.4672 27.3549 18.4527C27.2822 18.4382 27.2154 18.4025 27.1629 18.3501C27.1105 18.2976 27.0747 18.2308 27.0603 18.1581C27.0458 18.0853 27.0532 18.0099 27.0816 17.9414C27.11 17.8729 27.1581 17.8143 27.2197 17.7731C27.2814 17.7319 27.3539 17.7099 27.4281 17.7099C27.5275 17.7099 27.6229 17.7494 27.6932 17.8198C27.7636 17.8901 27.8031 17.9855 27.8031 18.0849ZM25.9633 15.1956C26.0375 15.1956 26.11 15.2176 26.1717 15.2588C26.2333 15.3 26.2814 15.3586 26.3098 15.4271C26.3382 15.4956 26.3456 15.571 26.3311 15.6438C26.3167 15.7165 26.281 15.7833 26.2285 15.8358C26.1761 15.8882 26.1092 15.9239 26.0365 15.9384C25.9638 15.9529 25.8884 15.9454 25.8198 15.9171C25.7513 15.8887 25.6927 15.8406 25.6515 15.7789C25.6103 15.7173 25.5883 15.6448 25.5883 15.5706C25.5883 15.4712 25.6279 15.3758 25.6982 15.3054C25.7685 15.2351 25.8639 15.1956 25.9633 15.1956ZM25.9797 23.913C25.9055 23.913 25.833 23.891 25.7713 23.8498C25.7097 23.8086 25.6616 23.75 25.6332 23.6815C25.6048 23.613 25.5974 23.5376 25.6119 23.4648C25.6264 23.3921 25.6621 23.3253 25.7145 23.2728C25.767 23.2204 25.8338 23.1847 25.9065 23.1702C25.9793 23.1557 26.0547 23.1631 26.1232 23.1915C26.1917 23.2199 26.2503 23.268 26.2915 23.3296C26.3327 23.3913 26.3547 23.4638 26.3547 23.538C26.3547 23.6374 26.3152 23.7328 26.2449 23.8031C26.1745 23.8735 26.0791 23.913 25.9797 23.913ZM26.8618 16.3563C26.936 16.3563 27.0085 16.3783 27.0702 16.4195C27.1319 16.4607 27.1799 16.5193 27.2083 16.5878C27.2367 16.6563 27.2441 16.7317 27.2296 16.8045C27.2152 16.8772 27.1795 16.944 27.127 16.9965C27.0746 17.0489 27.0077 17.0846 26.935 17.0991C26.8623 17.1136 26.7869 17.1061 26.7183 17.0778C26.6498 17.0494 26.5912 17.0013 26.55 16.9396C26.5088 16.878 26.4868 16.8055 26.4868 16.7313C26.4868 16.6821 26.4965 16.6333 26.5154 16.5878C26.5342 16.5423 26.5619 16.501 26.5967 16.4661C26.6315 16.4313 26.6728 16.4037 26.7183 16.3848C26.7638 16.366 26.8126 16.3563 26.8618 16.3563ZM26.8727 22.75C26.7985 22.75 26.726 22.728 26.6643 22.6868C26.6027 22.6456 26.5546 22.587 26.5262 22.5185C26.4978 22.45 26.4904 22.3746 26.5049 22.3019C26.5194 22.2291 26.5551 22.1623 26.6075 22.1098C26.66 22.0574 26.7268 22.0217 26.7995 22.0072C26.8723 21.9927 26.9477 22.0002 27.0162 22.0286C27.0847 22.0569 27.1433 22.105 27.1845 22.1667C27.2257 22.2283 27.2477 22.3008 27.2477 22.375C27.2477 22.4745 27.2082 22.5699 27.1379 22.6402C27.0675 22.7105 26.9721 22.75 26.8727 22.75ZM27.4347 21.3925C27.3605 21.3925 27.288 21.3705 27.2263 21.3293C27.1646 21.2881 27.1166 21.2295 27.0882 21.161C27.0598 21.0925 27.0524 21.0171 27.0669 20.9443C27.0813 20.8716 27.117 20.8048 27.1695 20.7523C27.2219 20.6999 27.2887 20.6642 27.3615 20.6497C27.4342 20.6352 27.5096 20.6427 27.5782 20.671C27.6467 20.6994 27.7052 20.7475 27.7465 20.8092C27.7877 20.8708 27.8097 20.9433 27.8097 21.0175C27.8097 21.117 27.7701 21.2123 27.6998 21.2827C27.6295 21.353 27.5341 21.3925 27.4347 21.3925ZM27.625 19.9262C27.5508 19.9262 27.4783 19.9042 27.4167 19.863C27.355 19.8218 27.3069 19.7633 27.2785 19.6947C27.2502 19.6262 27.2427 19.5508 27.2572 19.4781C27.2717 19.4053 27.3074 19.3385 27.3598 19.2861C27.4123 19.2336 27.4791 19.1979 27.5518 19.1834C27.6246 19.169 27.7 19.1764 27.7685 19.2048C27.837 19.2332 27.8956 19.2812 27.9368 19.3429C27.978 19.4046 28 19.4771 28 19.5512C28 19.6507 27.9605 19.7461 27.8902 19.8164C27.8198 19.8867 27.7244 19.9262 27.625 19.9262Z"
              fill="url(#paint0_linear_6052_11335)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_6052_11335"
              x1="22"
              y1="10"
              x2="22"
              y2="34"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FD4E1D" />
              <stop offset="1" stop-color="#FFCD0F" />
            </linearGradient>
            <clipPath id="clip0_6052_11335">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(10 10)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      label: "Early Leadership",
      icon: (
        <svg
          width="44"
          height="45"
          viewBox="0 0 44 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="22"
            cy="22.833"
            r="22"
            fill="#F1A80A"
            fill-opacity="0.05"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22 24.9157L21.4515 25.2438L21.6039 25.7852L20.9894 28.8149C20.3039 27.5845 19.6691 25.479 19.2984 24.1446C18.1914 24.5329 16.6476 24.6477 16.0992 25.654C15.5304 26.6821 15.2714 28.968 15.18 30.7946C15.175 30.9368 15.2257 31.0626 15.3324 31.1665C15.439 31.2704 15.5761 31.3196 15.7335 31.3196H28.2562C28.4136 31.3196 28.5507 31.2649 28.6574 31.1665C28.7691 31.0626 28.8199 30.9368 28.8097 30.7946C28.7183 28.968 28.4543 26.6821 27.8906 25.654C27.3371 24.6477 25.7984 24.5329 24.6914 24.1446C24.3207 25.479 23.6859 27.5845 23.0003 28.8149L22.3859 25.7852L22.5382 25.2438L22 24.9157ZM25.0265 18.3587V16.0454C23.823 14.0712 22 14.2407 22 14.2407C22 14.2407 20.182 14.0712 18.9734 16.0454V18.3587C18.9734 18.3587 17.9781 19.7696 19.339 20.9509C19.339 20.9509 19.9433 23.2641 21.9949 23.3188C24.0515 23.2641 24.6507 20.9509 24.6507 20.9509C26.0168 19.7696 25.0265 18.3587 25.0265 18.3587Z"
            fill="#F1A80A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34.0051 25.3641C33.5938 24.6149 32.441 24.5274 31.6133 24.2375L30.5266 23.3407C31.3239 22.843 31.5828 21.8532 31.5828 21.8532C32.5985 20.9672 31.8571 19.9117 31.8571 19.9117V18.1836C30.9582 16.7071 29.5973 16.8328 29.5973 16.8328C29.5973 16.8328 28.2364 16.7071 27.3375 18.1836V19.9117C27.3375 19.9117 26.591 20.9672 27.6118 21.8532C27.6118 21.8532 27.8758 22.843 28.668 23.3407L27.5813 24.2375C27.5356 24.2539 27.4899 24.2649 27.4442 24.2813C27.8707 24.511 28.2414 24.8227 28.4953 25.2766C29.0438 26.2774 29.3078 28.1258 29.4297 29.6024H34.2844C34.4012 29.6024 34.5028 29.5641 34.584 29.4875C34.6653 29.411 34.7059 29.318 34.7008 29.2086C34.6246 27.8414 34.4317 26.1352 34.0051 25.3641ZM15.5106 25.2711C15.7594 24.8117 16.1352 24.5055 16.5618 24.2758C16.516 24.2594 16.4653 24.2485 16.4246 24.2321L15.3379 23.3352C16.1352 22.8375 16.3942 21.8477 16.3942 21.8477C17.4098 20.9617 16.6684 19.9063 16.6684 19.9063V18.1782C15.7696 16.7016 14.4086 16.8274 14.4086 16.8274C14.4086 16.8274 13.0477 16.7016 12.1489 18.1782V19.9063C12.1489 19.9063 11.4024 20.9617 12.4231 21.8477C12.4231 21.8477 12.6871 22.8375 13.4793 23.3352L12.3926 24.2321C11.5649 24.5219 10.4121 24.6094 10.0008 25.3586C9.56917 26.1352 9.37621 27.8414 9.30511 29.2086C9.30003 29.3125 9.34066 29.4055 9.42191 29.4875C9.50316 29.5641 9.60472 29.6024 9.72152 29.6024H14.5762C14.6981 28.1203 14.9621 26.2719 15.5106 25.2711Z"
            fill="#D94545"
          />
        </svg>
      ),
    },
  ];
  const navigate = useNavigate();

  return (
    <Modal open={open} onClose={handleClose}>
     <Grid
        container
        direction="column"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#FEFCF8",
          borderRadius: "12px",
          width: 940,
          p: 4,
          boxShadow: 24,
          textAlign: "center",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            zIndex: 2,
            position: "absolute",
            top: -16,
            right: -16,
            backgroundColor: "#CE0E00",
            color: "white",
            "&:hover": { backgroundColor: "#A50C00" },
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Grid display={"flex"} justifyContent={"space-between"}>
          {/* Bulb */}
          <Grid>
            <svg
              width="60"
              height="68"
              viewBox="0 0 60 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M51.295 58.4797L35.3247 65.024C34.1916 65.4883 32.8977 64.9462 32.4333 63.8131L32.2853 63.4531C31.821 62.32 32.3631 61.0261 33.4962 60.5617L49.6529 53.9408C50.786 53.4765 52.0799 54.0186 52.5442 55.1517L52.6156 55.3253C53.1225 56.5617 52.5315 57.9739 51.295 58.4797Z"
                fill="#DDE2E0"
              />
              <path
                d="M50.3995 63.5841L40.0469 67.8259C38.8627 68.3115 37.5091 67.7449 37.0245 66.5607L36.9532 66.3871C36.4675 65.2028 37.0341 63.8493 38.2183 63.3647L48.5709 59.1219C49.7552 58.6362 51.1087 59.2028 51.5933 60.387L51.6647 60.5607C52.1503 61.746 51.5837 63.0995 50.3995 63.5841Z"
                fill="#DDE2E0"
              />
              <path
                d="M51.3745 37.4513C55.706 25.4303 49.4725 12.1741 37.4516 7.84256C25.4307 3.51104 12.1744 9.74453 7.84291 21.7655C3.51139 33.7864 9.74488 47.0426 21.7658 51.3742C33.7867 55.7057 47.043 49.4722 51.3745 37.4513Z"
                fill="#DECBF5"
              />
              <path
                d="M27.4727 51.9491L33.8369 58.7596L48.6443 52.5082L48.2619 41.0396L27.4727 51.9491Z"
                fill="#DECBF5"
              />
              <path
                d="M37.0048 56.8065C33.0048 51.6041 29.4414 46.0758 26.3903 40.2643C25.1592 37.9192 21.4935 32.3793 25.2113 30.5571C26.6618 29.8468 28.3647 30.3473 29.5383 31.3388C30.8163 32.4176 32.5458 34.8607 32.0378 36.6264C31.6044 38.1312 29.9749 38.1024 29.2114 36.8873C28.8652 36.3378 28.6885 35.6988 28.5713 35.0662C28.2241 33.1823 28.5543 31.0363 30.2369 29.8777C33.107 27.9021 36.6363 29.7456 38.4329 32.2483C38.9718 32.9991 39.6662 34.079 39.3499 35.046C38.6832 37.0864 36.7812 35.6051 36.2498 34.5295C35.5352 33.0822 35.434 31.1822 36.1358 29.7115C36.7886 28.3441 38.2018 27.4517 39.729 27.5273C41.6279 27.621 42.5427 29.2483 42.712 30.9703C42.8835 32.7147 42.6066 34.5092 42.564 36.2568C42.5192 38.1365 42.5597 40.0183 42.6864 41.8937C42.9431 45.685 43.5522 49.439 44.4745 53.1249C44.5991 53.6233 45.3702 53.4124 45.2445 52.913C43.8813 47.4688 43.2264 41.8713 43.3627 36.2579C43.4362 33.2099 44.5768 27.4123 40.1678 26.7722C36.4947 26.2387 34.4042 29.932 34.9878 33.1599C35.2615 34.6753 36.0985 36.5859 37.8216 36.8308C39.2966 37.0396 40.2913 35.7488 40.2008 34.3622C40.0826 32.5465 38.4585 30.7573 37.0772 29.7179C35.6363 28.6338 33.8557 28.0544 32.0538 28.3409C28.1262 28.966 26.763 33.2036 28.1815 36.6083C28.697 37.8458 29.8621 39.0907 31.3179 38.5497C32.894 37.964 33.1368 36.0694 32.6693 34.6615C31.6438 31.571 28.1347 27.9841 24.6575 29.9522C22.8769 30.9597 22.5702 33.1226 23.0622 34.9533C23.7577 37.5433 25.3402 40.0439 26.6192 42.3815C29.4584 47.5711 32.7098 52.5221 36.3158 57.2112C36.6246 57.6116 37.319 57.2144 37.0048 56.8065Z"
                fill="white"
              />
              <path
                d="M50.9095 53.7754L32.5899 61.2824C31.4056 61.768 30.052 61.2014 29.5675 60.0172L29.4961 59.8436C29.0105 58.6594 29.5771 57.3058 30.7613 56.8212L49.0809 49.3142C50.2652 48.8286 51.6188 49.3952 52.1033 50.5794L52.1747 50.753C52.6603 51.9372 52.0937 53.2908 50.9095 53.7754Z"
                fill="#DDE2E0"
              />
              <path
                d="M32.3941 61.7527C38.6626 59.216 44.932 56.6792 51.2005 54.1425C51.6712 53.9518 51.4656 53.1787 50.9885 53.3725C44.7201 55.9092 38.4506 58.446 32.1822 60.9827C31.7115 61.1734 31.917 61.9455 32.3941 61.7527Z"
                fill="#DECBF5"
              />
              <path
                d="M36.8176 64.9475C41.4716 63.0029 46.1244 61.0593 50.7783 59.1146C51.2459 58.9198 51.0403 58.1466 50.5664 58.3447C45.9125 60.2893 41.2596 62.2329 36.6057 64.1775C36.1382 64.3735 36.3437 65.1467 36.8176 64.9475Z"
                fill="#DECBF5"
              />
              <g opacity="0.3">
                <path
                  d="M16.7492 14.6677C19.6715 13.8999 20.8707 16.0799 21.27 18.1779C21.6694 20.2759 20.8803 22.4047 19.9985 24.3494C19.1167 26.294 18.1071 28.2653 18.0347 30.3995C17.9899 31.7115 18.3073 33.0097 18.3574 34.3218C18.4074 35.6338 18.1305 37.063 17.1465 37.9331C15.9803 38.964 14.1124 38.8681 12.7939 38.0396C11.4755 37.211 10.6278 35.8053 10.0378 34.3643C7.32213 27.7296 8.69488 19.9489 14.5 15.7412C14.5 15.7412 16.0219 14.8584 16.7492 14.6677Z"
                  fill="white"
                />
              </g>
            </svg>
          </Grid>

          {/* Header Badge */}
          <Grid justifyContent="center" mt={1}>
            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                bgcolor: "#F4DDF4",
                borderRadius: "30px",
                px: 2,
                py: 0.5,
              }}
            >
              <Grid>
                <svg
                  width="25"
                  height="26"
                  viewBox="0 0 25 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.0766 3.41553C19.2934 2.85598 16.6156 1.86174 14.1416 0.469349C13.617 0.162007 13.02 0 12.412 0C11.804 0 11.2069 0.162007 10.6823 0.469349C8.20835 1.86174 5.5306 2.85598 2.74741 3.41553C1.97423 3.5784 1.28008 4.00096 0.780308 4.61297C0.280541 5.22499 0.00526374 5.9896 0.000228025 6.77973V8.96747C-0.0151428 11.996 0.746819 14.9779 2.21323 17.6278C3.67964 20.2777 5.80145 22.5071 8.37569 24.1026L10.5947 25.4793C11.1389 25.8196 11.7677 26 12.4095 26C13.0512 26 13.6801 25.8196 14.2242 25.4793L16.442 24.1026C19.0174 22.5079 21.1405 20.2788 22.608 17.6289C24.0755 14.9789 24.8384 11.9966 24.8237 8.96747V6.77973C24.8187 5.9896 24.5434 5.22499 24.0437 4.61297C23.5439 4.00096 22.8497 3.5784 22.0766 3.41553Z"
                    fill="#F1B95C"
                  />
                  <path
                    d="M13.6645 15.183C13.5412 15.1833 13.4191 15.1592 13.3052 15.1119C13.1913 15.0646 13.088 14.9952 13.0012 14.9077L10.498 12.4046C10.3322 12.2266 10.2419 11.9913 10.2462 11.7481C10.2505 11.5049 10.349 11.2729 10.521 11.1009C10.693 10.9289 10.925 10.8304 11.1682 10.8261C11.4114 10.8218 11.6467 10.9121 11.8247 11.0779L13.6645 12.9165L19.259 7.32322C19.4369 7.15741 19.6723 7.06714 19.9154 7.07144C20.1586 7.07573 20.3906 7.17424 20.5626 7.34622C20.7346 7.5182 20.8331 7.75022 20.8374 7.9934C20.8417 8.23658 20.7514 8.47193 20.5856 8.64988L14.3278 14.9077C14.241 14.9952 14.1376 15.0646 14.0238 15.1119C13.9099 15.1592 13.7878 15.1833 13.6645 15.183Z"
                    fill="#FCC400"
                  />
                  <path
                    d="M12.4106 18.312C11.4463 18.3137 10.496 18.0808 9.64167 17.6333C8.78738 17.1859 8.05478 16.5373 7.50704 15.7436C6.9593 14.9499 6.61288 14.0348 6.49766 13.0773C6.38244 12.1199 6.50188 11.1487 6.84567 10.2477C7.18946 9.34671 7.74729 8.54286 8.47103 7.90551C9.19477 7.26816 10.0627 6.81644 11 6.58933C11.9372 6.36222 12.9156 6.36652 13.8508 6.60187C14.7861 6.83723 15.65 7.29656 16.3681 7.94026C16.4688 8.01973 16.5521 8.119 16.6129 8.23193C16.6737 8.34486 16.7108 8.46906 16.7217 8.59686C16.7327 8.72466 16.7173 8.85335 16.6766 8.97499C16.6359 9.09663 16.5707 9.20863 16.485 9.30408C16.3993 9.39953 16.295 9.47641 16.1784 9.52997C16.0619 9.58353 15.9356 9.61263 15.8074 9.61548C15.6791 9.61833 15.5517 9.59487 15.4328 9.54654C15.314 9.49822 15.2064 9.42605 15.1165 9.3345C14.3741 8.6659 13.4097 8.29702 12.4106 8.29945C11.3319 8.29945 10.2973 8.728 9.53443 9.49082C8.77161 10.2536 8.34306 11.2882 8.34306 12.367C8.34306 13.4458 8.77161 14.4804 9.53443 15.2433C10.2973 16.0061 11.3319 16.4346 12.4106 16.4346C12.6244 16.4331 12.8378 16.4155 13.0489 16.3821C13.4371 16.3207 13.8139 16.2013 14.1666 16.0279C14.9995 15.632 15.6708 14.9616 16.0677 14.1292C16.1746 13.9044 16.3664 13.7311 16.601 13.6477C16.8356 13.5643 17.0938 13.5774 17.3187 13.6843C17.5435 13.7912 17.7168 13.983 17.8002 14.2176C17.8836 14.4522 17.8705 14.7104 17.7636 14.9352C17.182 16.1548 16.1994 17.1378 14.9801 17.72C14.459 17.9746 13.9025 18.1492 13.3293 18.2381C13.0253 18.2855 12.7183 18.3102 12.4106 18.312Z"
                    fill="white"
                  />
                  <path
                    d="M22.0766 3.41553C19.2934 2.85598 16.6156 1.86174 14.1416 0.469349C13.617 0.162007 13.02 0 12.412 0C11.804 0 11.2069 0.162007 10.6823 0.469349C8.20835 1.86174 5.5306 2.85598 2.74741 3.41553C1.97423 3.5784 1.28008 4.00096 0.780308 4.61297C0.280541 5.22499 0.00526374 5.9896 0.000228025 6.77973V8.96747C-0.0151428 11.996 0.746819 14.9779 2.21323 17.6278C3.67964 20.2777 5.80145 22.5071 8.37569 24.1026L10.5947 25.4793C11.1389 25.8196 11.7677 26 12.4095 26C13.0512 26 13.6801 25.8196 14.2242 25.4793L16.442 24.1026C19.0174 22.5079 21.1405 20.2788 22.608 17.6289C24.0755 14.9789 24.8384 11.9966 24.8237 8.96747V6.77973C24.8187 5.9896 24.5434 5.22499 24.0437 4.61297C23.5439 4.00096 22.8497 3.5784 22.0766 3.41553Z"
                    fill="#F1B95C"
                  />
                  <path
                    d="M12.4106 18.312C11.4463 18.3137 10.496 18.0808 9.64167 17.6333C8.78738 17.1859 8.05478 16.5373 7.50704 15.7436C6.9593 14.9499 6.61288 14.0348 6.49766 13.0773C6.38244 12.1199 6.50188 11.1487 6.84567 10.2477C7.18946 9.34671 7.74729 8.54286 8.47103 7.90551C9.19477 7.26816 10.0627 6.81644 11 6.58933C11.9372 6.36222 12.9156 6.36652 13.8508 6.60187C14.7861 6.83723 15.65 7.29656 16.3681 7.94026C16.4688 8.01973 16.5521 8.119 16.6129 8.23193C16.6737 8.34486 16.7108 8.46906 16.7217 8.59686C16.7327 8.72466 16.7173 8.85335 16.6766 8.97499C16.6359 9.09663 16.5707 9.20863 16.485 9.30408C16.3993 9.39953 16.295 9.47641 16.1784 9.52997C16.0619 9.58353 15.9356 9.61263 15.8074 9.61548C15.6791 9.61833 15.5517 9.59487 15.4328 9.54654C15.314 9.49822 15.2064 9.42605 15.1165 9.3345C14.3741 8.6659 13.4097 8.29702 12.4106 8.29945C11.3319 8.29945 10.2973 8.728 9.53443 9.49082C8.77161 10.2536 8.34306 11.2882 8.34306 12.367C8.34306 13.4458 8.77161 14.4804 9.53443 15.2433C10.2973 16.0061 11.3319 16.4346 12.4106 16.4346C12.6244 16.4331 12.8378 16.4155 13.0489 16.3821C13.4371 16.3207 13.8139 16.2013 14.1666 16.0279C14.9995 15.632 15.6708 14.9616 16.0677 14.1292C16.1746 13.9044 16.3664 13.7311 16.601 13.6477C16.8356 13.5643 17.0938 13.5774 17.3187 13.6843C17.5435 13.7912 17.7168 13.983 17.8002 14.2176C17.8836 14.4522 17.8705 14.7104 17.7636 14.9352C17.182 16.1548 16.1994 17.1378 14.9801 17.72C14.459 17.9746 13.9025 18.1492 13.3293 18.2381C13.0253 18.2855 12.7183 18.3102 12.4106 18.312Z"
                    fill="white"
                  />
                  <path
                    d="M2.94072 4.33416C5.82047 3.75158 8.59121 2.72158 11.1522 1.2816C11.5348 1.05864 11.9697 0.941162 12.4126 0.941162C12.8554 0.941162 13.2903 1.05864 13.6729 1.2816C16.2339 2.72158 19.0046 3.75158 21.8844 4.33416C22.4485 4.44931 22.9557 4.75542 23.3205 5.20089C23.6852 5.64636 23.8853 6.20396 23.8869 6.77972V8.96745C23.8914 11.8347 23.1653 14.6558 21.7772 17.1646C20.3891 19.6734 18.3848 21.7872 15.9532 23.3066L13.7355 24.6833C13.3388 24.93 12.8809 25.0607 12.4138 25.0607C11.9467 25.0607 11.4889 24.93 11.0922 24.6833L8.87439 23.3066C6.44261 21.7874 4.438 19.6736 3.04968 17.1648C1.66137 14.656 0.935122 11.8348 0.939473 8.96745V6.77972C0.941023 6.20414 1.14089 5.64667 1.50541 5.20123C1.86993 4.75578 2.37683 4.44957 2.94072 4.33416Z"
                    stroke="#2A3330"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.4117 18.312C15.695 18.312 18.3566 15.6503 18.3566 12.367C18.3566 9.08375 15.695 6.42212 12.4117 6.42212C9.12843 6.42212 6.4668 9.08375 6.4668 12.367C6.4668 15.6503 9.12843 18.312 12.4117 18.312Z"
                    fill="white"
                  />
                  <path
                    d="M13.6645 15.183C13.5412 15.1833 13.4191 15.1592 13.3052 15.1119C13.1913 15.0646 13.088 14.9952 13.0012 14.9077L10.498 12.4046C10.3322 12.2266 10.2419 11.9913 10.2462 11.7481C10.2505 11.5049 10.349 11.2729 10.521 11.1009C10.693 10.9289 10.925 10.8304 11.1682 10.8261C11.4114 10.8218 11.6467 10.9121 11.8247 11.0779L13.6645 12.9165L19.259 7.32322C19.4369 7.15741 19.6723 7.06714 19.9154 7.07144C20.1586 7.07573 20.3906 7.17424 20.5626 7.34622C20.7346 7.5182 20.8331 7.75022 20.8374 7.9934C20.8417 8.23658 20.7514 8.47193 20.5856 8.64988L14.3278 14.9077C14.241 14.9952 14.1376 15.0646 14.0238 15.1119C13.9099 15.1592 13.7878 15.1833 13.6645 15.183Z"
                    fill="#572575"
                  />
                </svg>
              </Grid>

              <Typography
                variant="body2"
                sx={{
                  color: "#161719",
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "14px",
                }}
              >
                Profile Building Overview
              </Typography>
            </Grid>
          </Grid>
          {/* Plane */}
          <Grid>
            <svg
              width="80"
              height="40"
              viewBox="0 0 80 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.747617 2.87822C5.5197 -2.72089 17.9233 0.799199 26.4245 5.37953C26.4245 5.37953 32.2734 8.15464 34.451 9.59383C34.4748 9.59937 34.4968 9.6049 34.5207 9.61043L54.3972 7.11284C56.0111 6.91001 57.6488 7.1995 59.0978 7.9426L60.7264 8.77791C61.5494 9.20017 61.5081 10.396 60.6595 10.762L46.027 17.0544C46.0206 17.1355 46.0197 17.154 46.0132 17.236C53.7932 22.3788 60.4578 26.7839 60.4578 26.7839C60.5293 26.8319 60.6008 26.8807 60.6741 26.9268C63.3951 28.6749 66.6779 29.3396 69.8737 28.7643L77.6106 27.3731C78.0028 27.303 78.4134 27.3196 78.7818 27.4717C80.1565 28.0397 80.4223 29.8569 79.2987 30.8019L70.3384 38.339C68.9352 39.52 66.9804 39.7818 65.3188 39.012L61.1232 37.0694L39.8912 26.8992L42.3281 39.0609C42.4179 39.5615 42.0248 40.0188 41.5189 39.9994L40.5181 39.9626C39.1479 39.9118 37.8997 39.154 37.2178 37.9573L28.6607 21.5195L3.61253 9.52102C0.272889 7.9758 -0.919452 5.09463 0.747617 2.87822Z"
                fill="#DECBF5"
              />
            </svg>
          </Grid>
        </Grid>
        {/* Title */}
        <Grid item mt={2}>
          <Typography
            fontFamily={"Inter"}
            fontWeight={400}
            fontSize={"30px"}
            color={"#161719"}
          >
            Your Personalized Study Abroad{" "}
            <span style={{ color: "#6B1F91" }}>Planner</span>
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item mt={1}>
          <Typography
            fontWeight={400}
            color="#313439"
            fontSize="18px"
            sx={{
              maxWidth: "70%", // keeps it narrow
              mx: "auto", // centers it
            }}
          >
            Choose your passion, and we’ll chart your study abroad timeline like
            magic!
          </Typography>
        </Grid>

        {/* Options Grid */}
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          mt={3}
        >
          {options.map((item, index) => (
            <Grid item xs={5} sm={4} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 1,
                  textAlign: "center",
                  borderRadius: "12px",
                  border: "0.64px solid #7E838D",
                  cursor: "pointer",
                  "&:hover": { boxShadow: 6 },
                }}
              >
                <Grid display="flex" justifyContent="center" mb={1}>
                  {item.icon}
                </Grid>
                <Typography color={"#161719"} fontWeight={500}>
                  {item.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* CTA Button */}
        <Grid item mt={4}>
          <Button
            variant="contained"
            onClick={() => {
              navigate("/sap/timeline");
            }}
            sx={{
              backgroundColor: "#572575",
              "&:hover": { backgroundColor: "#572575" },
              borderRadius: "12px",
              px: 4,
              py: 1.2,
              fontWeight: 600,
              textTransform: "none",
              fontSize: "16px",
            }}
          >
            Enroll To Get Customized Timeline
          </Button>
        </Grid>
      </Grid> 
    </Modal>
  );
};

export default ProfileBuildingModal;
